export enum QueryString {
  Simulated = "simulated",
  SignUp = "signup",
  Reconnect = "reconnect",
  ReturnUrl = "returnUrl",
  Tesla = "tesla",
  ShowLandingPage = "landing",
  Referrer = "referrer"
};